var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meter-device-search pa-10"},[_c('title-page',{attrs:{"icon":"mdi-counter"}},[_vm._v(" "+_vm._s(_vm.$t('meter-device.search'))+" ")]),_c('meter-device-list',{attrs:{"with-control":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }